/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { CheckmarkFilled, ErrorFilled } from '@carbon/icons-react';

import { ExtractionStatus } from './TestTemplateOverviewResults.styled';

/**
 * A reusable component for displaying extraction status with consistent styling
 * @param {object} props
 * @param {'success' | 'missing' | boolean} props.status - Extraction status or boolean indicating if extracted
 * @returns {JSX.Element|null}
 */
export const ExtractionStatusIndicator = ({ status }) => {
  const isSuccess = status === 'success' || status === true;
  const isMissing = status === 'missing' || status === false;

  if (isSuccess) {
    return (
      <ExtractionStatus>
        <CheckmarkFilled fill="var(--cds-support-success)" aria-label="success" /> Success
      </ExtractionStatus>
    );
  }

  if (isMissing) {
    return (
      <ExtractionStatus>
        <ErrorFilled fill="var(--cds-support-error)" aria-label="error" /> Missing
      </ExtractionStatus>
    );
  }

  return null;
};
